import React from "react";
import "./SubHeaderMainPage.scss";
import StarRating from "../StarRating/StarRating";
import commaSeparator from "../../Utils/CommaSeparator";
import MySwiper from "../Swiper/MySwiper";
import {Link} from "react-router-dom";
import IconViewer from "../../Assets/svg/IconViewer";

const SubHeaderMainPage = ({sliderImages, cardData}) => {

  return (
    <div className="subHeader_">
      <div className="subHeaderRightSlider_" style={cardData.length === 0 ? {width: '100%'} : {}}>
        <MySwiper slideImages={sliderImages}/>
      </div>

      {cardData.length > 0 && <>
        <div className="subHeaderLeftSlider_">
          <Link
            to={`/Group/product/${cardData[0]?.id}`}
            state={{id: cardData[0]?.id}}
            className="spacialCardPrnt_"
          >
            {cardData[0]?.offer && (
              <div className="offerPercentSpacial_">{cardData[0]?.offPercent}%</div>
            )}
            <div className="spacialCardImg_">
              {cardData[0].length !== 0 && (
                <img src={cardData[0]?.images[0]?.url} alt=""/>
              )}
            </div>
            <h6>{cardData[0]?.title}</h6>
            <div className="productCardDtailsParentSpacial__">
              <div className="productCardDtailsSpacial__">
              <span className="productCardMainPriceSpacial__">
                {/* <span className="PriceSpacial_">قیمت : </span> */}
                <span
                  style={
                    cardData[0]?.offer
                      ? {textDecorationLine: "line-through"}
                      : {}
                  }
                >
                  {commaSeparator(cardData[0]?.mainPrice)}
                </span>
                {cardData[0]?.offer === false && "ریال"}
                {cardData[0]?.offer && (
                  <span className="productCardOfferPriceSpacial_">
                    {commaSeparator(cardData[0]?.mainPrice - cardData[0]?.offerPrice)}{" "}
                    ریال
                  </span>
                )}
              </span>
                <span className="ProductCardscoreSpacial__">
                {/* <span className="PriceSpacial_">امتیاز:</span>{" "} */}
                  <span className="scoreSpacial_">{`(${cardData[0]?.score})`}</span>
                <span className="scoreIconsSpacial__">
                  <StarRating rating={cardData[0]?.score}/>
                </span>
              </span>
              </div>
              <div className="shopIconSpacial__">
                <IconViewer icon={"GreenCardBag"}/>
              </div>
            </div>
          </Link>
        </div>
        {/* responsive left side */}
        <div className="subHeaderLeftSliderResponsive_">
          <Link
            to={`/Group/product/${cardData[0]?.id}`}
            className="spacialCardPrntRes_"
          >
            {Math.round(cardData[0]?.offer) && (
              <div className="offerPercentSpacialRes_">
                {cardData[0]?.offPercent}%
              </div>
            )}
            <div className="spacialCardImgRes_">
              <img
                src={cardData[0]?.images?.length > 0 && cardData[0]?.images[0]?.url}
                alt=""
              />
            </div>
            <div className="contentCardRes__">
              <h6>{cardData[0]?.title}</h6>
              <div className="productCardDtailsParentSpacial__">
                <div className="productCardDtailsSpacial__">
                <span className="productCardMainPriceSpacial__">
                  {/* <span className="PriceSpacial_">قیمت : </span> */}
                  {commaSeparator(cardData[0]?.mainPrice)}
                  {cardData[0]?.offer === false && "ریال"}
                  {cardData[0]?.offer && (
                    <span className="productCardOfferPriceSpacial_">
                      {commaSeparator(cardData[0]?.offerPrice)} ریال
                    </span>
                  )}
                </span>
                  <span className="ProductCardscoreSpacial__">
                  {/* <span className="PriceSpacial_">امتیاز:</span>{" "} */}
                    <span className="scoreSpacial_">{`(${cardData[0]?.score})`}</span>
                  <span className="scoreIconsSpacial__">
                    <StarRating rating={cardData[0]?.score}/>
                  </span>
                </span>
                </div>
                <div className="shopIconSpacial__">
                  <IconViewer icon={"GreenCardBag"}/>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </>}
    </div>
  );
};

export default SubHeaderMainPage;
